import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Grid, IconButton, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
    noInternetMsg,
    savemsg,
    saveWarningMsg,
    serverMsg
} from "../../config/messageconstant";
import excelIcon from "../../Images/excel-icon.png";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel } from "../PDF/PDFDownload";
import ExportPopUp from "./ExportPopUp";
import ImportPopUp from "./ImportPopUp";
const ExcelJS = require("exceljs");
class DateWisePJPImportExport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: dayjs(),
            toDate: dayjs(),
            salesTeam: "",
            searchValue: "",
            exportPopUpFlag: false,
            importPopUpFlag: false,
            patternObject: {},
        };

        this.tableStyles = {
            tabContainer: {
                display: "flex",
                marginBottom: "16px",
                borderBottom: "1px solid #E5F1F9",
            },
            tableWrapper: {
                maxHeight: "570px", // Adjust as needed for your layout
                overflowY: "auto",
                width: "100%",
                display: "block", // Ensures proper scroll behavior
                borderBottom: "1px solidrgb(182, 186, 188)",
            },
            table: {
                width: "100%",
                borderCollapse: "collapse",
                display: "table",
                borderBottom: "1px solidrgb(182, 186, 188)",

            },
            stickyHeader: {
                position: "sticky",
                top: 0,
                backgroundColor: "#1C4E80", // Matches headerRow background
                zIndex: 10, // Ensures header stays above body
            },
            tab: {
                padding: "8px 16px",
                cursor: "pointer",
                color: "#333",
                fontSize: "14px",
                fontWeight: "500",
                transition: "color 0.2s ease-in-out",
            },
            activeTab: {
                color: "#1C4E80",
                borderBottom: "2px solid #1C4E80",
            },
            noData: {
                padding: "16px",
                textAlign: "center",
                fontSize: "14px",
                color: "#666",
            },
            tableContainer: {
                backgroundColor: "#fff",
                borderRadius: "10px",
                padding: "16px",
                maxWidth: "1000px",
                margin: "0 auto",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            },
            searchContainer: {
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                maxWidth: "300px",
            },
            headerRow: {
                backgroundColor: "rgb(233, 240, 243)",
                color: "#000",
                fontWeight: "bold",
                fontSize: "14px",
            },
            headerCell: {
                padding: "12px 16px",
                textAlign: "center",
                borderBottom: "2px solid #E5F1F9",
                fontWeight: 600,
            },
            dataRow: {
                backgroundColor: "#fff",
                transition: "background-color 0.2s ease-in-out",
            },
            dataRowHover: {
                backgroundColor: "#E5F1F9",
            },
            dataCell: {
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                borderBottom: "1px solid #E5F1F9",
            },
            amountCell: {
                color: "#004969",
                fontWeight: "500",
                fontSize: "13px",
            },
            alternateRow: {
                backgroundColor: "#fff",
            },
            searchInput: {
                width: "100%",
                padding: "8px 12px",
                fontSize: "14px",
                border: "1px solid #E5F1F9",
                borderRadius: "6px",
                outline: "none",
                color: "#333",
                transition: "border-color 0.3s ease-in-out",
            },
            searchInputFocus: {
                borderColor: "#1C4E80",
                boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
            },
        };
    }




    async componentDidMount() {
        const { getSalesExecutiveByUserType, showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            await getSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
                ({ success, response }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                }
            );
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }



    onClickOfExport = () => {
        this.setState({ exportPopUpFlag: true })
    }

    onClickOfImport = () => {
        this.setState({ importPopUpFlag: true })
    }




    onSearchBox = (e) => {
        this.setState({
            searchValue: e.target.value,
        });
    };

    getFilteredTableData = (searchData) => {
        const { searchValue } = this.state;
        return searchData.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["employeeCode"] &&
                    currentRow["employeeCode"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["salesTeamName"] &&
                    currentRow["salesTeamName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["designation"] &&
                    currentRow["designation"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["dmyDate"] &&
                    currentRow["dmyDate"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["dayName"] &&
                    currentRow["dayName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["beatCodes"] &&
                    currentRow["beatCodes"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["beatNames"] &&
                    currentRow["beatNames"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["errorMessage"] &&
                    currentRow["errorMessage"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase()))

            ) {
                isValid = true;
                return true;
            }
        });
    };

    onSubmit = () => {
        const { showLoador, showNotification } = this.props;
        const { patternObject } = this.state;

        let dataToSendList = Object.keys(patternObject).length !== 0 ? patternObject?.salesTeamWithDates : [];

        swal({
            title: "Are you sure?",
            text: saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiPost({
                    url: endpoint.projection + "/save-beat-projection",
                    postBody: dataToSendList,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        if (data && data.data && data.data.statusCode == 500) {
                            showNotification({
                                msg: data.data.message,
                                severity: "error",
                            });
                        } else {
                            showNotification({
                                msg: savemsg,
                            });
                            window.location.reload();
                        }
                    }
                });
            }
        });
    }


    exportPopUpClose = () => {
        this.setState({ exportPopUpFlag: false });
    }

    importPopUpClose = () => {
        this.setState({ importPopUpFlag: false });
    }

    dataMethod = (dataObj) => {
        this.setState({ patternObject: dataObj })
    }


    filterExcel = () => {
        const { patternObject } = this.state;

        if (Object.keys(patternObject).length === 0) {
            this.props.showNotification({
                msg: "No data available for export",
                severity: "error",
            });
            return;
        }

        const filteredData = this.getFilteredTableData(patternObject?.salesTeamWithDates);

        if (!filteredData || filteredData.length === 0) {
            this.props.showNotification({
                msg: "No data available for export",
                severity: "error",
            });
            return;
        }

        // Prepare column headers & rows
        const excelHeaders = [
            "Employee Code",
            "Sales Person Name",
            "Designation",
            "Date",
            "Day",
            "Beat Code",
            "Beat Name"
        ];

        const formattedRows = filteredData.map(row => [
            row.employeeCode || "-",
            row.salesTeamName || "-",
            row.designation || "-",
            row.dmyDate || "-",
            row.dayName || "-",
            row.beatCodes || "-",
            row.beatNames || "-"
        ]);

        // ---------------- Excel Generation Code ----------------
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet 1");

        // Put headers directly in first row (skip title & extra rows)
        excelHeaders.forEach((header, index) => {
            const cell = worksheet.getCell(1, index + 1);
            cell.value = header;
            cell.font = { bold: true, size: 12 };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // Add data rows
        formattedRows.forEach(rowData => {
            worksheet.addRow(rowData);
        });

        // Auto column width
        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                const cellValue = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, cellValue.length);
            });
            column.width = maxLength < 10 ? 10 : maxLength + 2;
        });

        // Freeze header row
        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        // Download file
        const fileName = "Date_Wise_PJP_Export" + " - " + new Date();
        workbook.xlsx.writeBuffer().then(data => {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = fileName + ".xls";
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };


    render() {
        const {
            fromDate,
            toDate,
            salesTeam,
            exportPopUpFlag,
            importPopUpFlag,
            patternObject
        } = this.state;

        return (
            <>
                <Paper
                    sx={{
                        borderRadius: 2,
                        p: { xs: 2, sm: 4 },
                        boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
                        // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
                        maxWidth: "auto",
                        margin: "auto",
                    }}
                    elevation={5}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <LandingScreenHeader
                            screenTitle="Date Wise PJP Import-Export"
                            showSaveBtnMain={false}
                            showAddButton={false}
                            showBackButton={false}
                        />

                        <div style={{ display: "flex", gap: 15 }}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="medium"
                                startIcon={<CloudDownloadIcon />}
                                sx={{
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    transition: "all 0.2s",
                                    minWidth: "120px",
                                    height: "35px",
                                    "&:hover": {
                                        backgroundColor: "#f4f6fa",
                                        borderColor: "#1976d2",
                                        color: "#1976d2",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                                onClick={this.onClickOfExport}
                            >
                                Export
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                                sx={{
                                    color: "#fff",
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    transition: "all 0.2s",
                                    minWidth: "150px",
                                    height: "35px",
                                    "&:hover": {
                                        backgroundColor: "#1976d2",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                                onClick={this.onClickOfImport}
                            >
                                Import
                            </Button>
                        </div>
                    </div>
                    <br />
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                        {/* Search Box */}
                        <input
                            type="text"
                            placeholder="Search..."
                            value={this.state.searchValue}
                            onChange={this.onSearchBox}
                            style={{
                                padding: "6px 10px",
                                fontSize: "14px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                width: "230px"
                            }}
                        />

                        {/* Excel Export Icon */}
                        <IconButton
                            onClick={this.filterExcel}
                            title="Export to Excel"
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e6f4ea")}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                            sx={{ padding: "6px" }}
                        >
                            <img
                                src={excelIcon}
                                alt="Export to Excel"
                                style={{
                                    width: 28,
                                    height: 28,
                                    objectFit: "contain",
                                    marginRight: 10,
                                }}
                            />
                        </IconButton>
                    </div>
                    <div style={this.tableStyles.tableWrapper}>
                        <table style={this.tableStyles.table}>
                            <thead style={this.tableStyles.stickyHeader}>
                                <tr style={this.tableStyles.headerRow}>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            width: "6%",
                                        }}>
                                        Sr.No
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "center",
                                            width: "13%",
                                        }}
                                    >
                                        Employee Code
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "left",
                                            width: "15%",
                                        }}
                                    >
                                        Sales Person Name
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "left",
                                            width: "13%",
                                        }}
                                    >
                                        Designation
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "center",
                                            width: "10%",
                                        }}
                                    >
                                        Date
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "left",
                                            width: "10%",
                                        }}
                                    >
                                        Day
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "left",
                                            width: "10%",
                                        }}
                                    >
                                        Beat Code
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "left",
                                            width: "13%",
                                        }}
                                    >
                                        Beat Name
                                    </th>
                                    <th
                                        style={{
                                            ...this.tableStyles.headerCell,
                                            textAlign: "left",
                                            width: "17%",
                                        }}
                                    >
                                        Error Message
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(patternObject).length !== 0 &&
                                    patternObject.salesTeamWithDates.length !== 0 &&
                                    this.getFilteredTableData(patternObject?.salesTeamWithDates).map((row, index) => (
                                        <tr
                                            key={index + 1}
                                            style={{
                                                ...this.tableStyles.dataRow,
                                                ...this.tableStyles.alternateRow,

                                                ...(index % 2 === 0 ? this.tableStyles.alternateRow : {}),
                                                ...(row.flag == 2 && { backgroundColor: "#ed8e98" })
                                            }}

                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                    this.tableStyles.dataRowHover.backgroundColor;
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                    row.flag == 2
                                                        ? "#ed8e98"
                                                        : index % 2 === 0
                                                            ? this.tableStyles.alternateRow.backgroundColor
                                                            : this.tableStyles.dataRow.backgroundColor;
                                            }}
                                        >
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "center",
                                                    width: "6%",
                                                }}
                                            >
                                                {index + 1}
                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "center",
                                                    width: "13%",
                                                }}
                                            >
                                                {row.employeeCode !== null ? row.employeeCode : "-"}
                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "left",
                                                    width: "15%",
                                                }}
                                            >
                                                {row.salesTeamName !== null ? row.salesTeamName : "-"}
                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "left",
                                                    width: "13%",
                                                }}
                                            >
                                                {row.designation !== null ? row.designation : "-"}                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "center",
                                                    width: "10%",
                                                }}
                                            >
                                                {row.dmyDate !== null ? row.dmyDate : "-"}
                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "left",
                                                    width: "10%",
                                                }}
                                            >
                                                {row.dayName !== null ? row.dayName : "-"}
                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "left",
                                                    width: "10%",
                                                }}
                                            >
                                                {row.beatCodes !== null ? row.beatCodes : "-"}

                                            </td>
                                            <td
                                                style={{
                                                    ...this.tableStyles.dataCell,
                                                    textAlign: "left",
                                                    width: "13%",
                                                }}
                                            >
                                                {row.beatNames !== null ? row.beatNames : "-"}
                                            </td>

                                            {row.flag == 2 ?
                                                (

                                                    <td
                                                        style={{
                                                            ...this.tableStyles.dataCell,
                                                            textAlign: "left",
                                                            width: "17%",
                                                        }}
                                                    >
                                                        {row.errorMessage !== null ? row.errorMessage : "-"}
                                                    </td>
                                                ) : (
                                                    <td
                                                        style={{
                                                            ...this.tableStyles.dataCell,
                                                            textAlign: "center",
                                                            width: "17%",
                                                        }}
                                                    >
                                                        {"-"}
                                                    </td>
                                                )}
                                        </tr>
                                    ))}

                                {Object.keys(patternObject).length === 0 && (
                                    <tr>
                                        <td colSpan="8" style={this.tableStyles.noData}>
                                            No Data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>



                    {Object.keys(patternObject).length !== 0 && (
                        <>
                            <Grid
                                item
                                sm={12}
                                xs={12}
                                md={12}
                                lg={12}
                                rowSpacing={2}
                                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                                container
                                justifyContent="right"
                                sx={{ marginTop: 3 }}
                            >
                                <ButtonCompo
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    name="Submit"
                                    onClick={this.onSubmit}
                                />
                            </Grid>
                        </>
                    )}


                    {exportPopUpFlag && (
                        <ExportPopUp
                            open={exportPopUpFlag}
                            handleCloses={this.exportPopUpClose}
                            fromDate={fromDate}
                            toDate={toDate}
                            salesTeam={salesTeam}
                            salesPersonList={this.props.salesPersonList}
                        />
                    )}


                    {importPopUpFlag && (
                        <ImportPopUp
                            open={importPopUpFlag}
                            handleCloses={this.importPopUpClose}
                            dataMethod={this.dataMethod}
                        />
                    )}


                </Paper >
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
    showLoador,
    showNotification,
    downloadExcel,
    getSalesExecutiveByUserType,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(DateWisePJPImportExport);

const thStyle = {
    padding: "12px 8px",
    background: "#f7fafc",
    color: "#1a237e",
    fontWeight: 600,
    borderBottom: "2px solid #e0e0e0",
    textAlign: "center",
    fontSize: "15px",
    letterSpacing: "0.02em",
    borderRight: "1px solid #e0e0e0" // Add this line!
};

const tdStyle = {
    padding: "10px 8px",
    borderBottom: "1px solid #eaeaea",
    textAlign: "left",
    fontSize: "15px",
    verticalAlign: "middle",
    borderRight: "1px solid #e0e0e0" // Add this line!
};

const tdCenterStyle = {
    ...tdStyle,
    textAlign: "center"
};